import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme, useMediaQuery } from "@mui/material";

function ResponsiveAppBar({ handleTabChange, currentTab, tabs }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleNavigation = (tab) => {
    handleTabChange(tab);
    setDrawerOpen(false);
  };

  return (
    <AppBar
      component="nav"
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      }}
    >
      <Toolbar
        disableGutters
        sx={{ px: 0, minHeight: { xs: 56, sm: 64 }, position: "relative" }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            paddingLeft: 2,
            flexShrink: 0,
          }}
        >
          <a href="/nordic-trials-dashboard" rel="noopener noreferrer">
            <img
              src="metaresearch_se_cropped.png"
              alt="MetaResearch.se Logo"
              style={{
                maxHeight: "25px",
                display: "block",
                objectFit: "contain",
              }}
            />
          </a>
        </Box>

        {/* Navigation buttons container */}
        <Box sx={{ flex: 1, height: "100%", position: "relative" }}>
          {/* Desktop Navigation Links */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              height: "100%",
              gap: 3,
              ml: 4,
            }}
          >
            {/* Vertical Divider */}
            <Box
              sx={{
                width: "1px",
                height: "24px",
                backgroundColor: "rgba(255,255,255,0.3)",
                mr: 1,
              }}
            />
            {tabs.map((item) => (
              <Typography
                key={item}
                variant="body1"
                onClick={() => handleTabChange(item)}
                sx={{
                  color: theme.palette.primary.contrastText,
                  fontWeight: currentTab === item ? "bold" : "normal",
                  cursor: "pointer",
                  textDecoration: currentTab === item ? "underline" : "none",
                  textUnderlineOffset: "4px",
                  "&:hover": {
                    textDecoration: "underline",
                    textUnderlineOffset: "4px",
                  },
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        </Box>

        {/* Menu Button - Show on mobile only */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="end"
          onClick={handleDrawerToggle}
          sx={{
            ml: "auto",
            mr: 2,
            display: { xs: "block", md: "none" },
          }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Navigation Drawer */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 280,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
        }}
      >
        <Box sx={{ p: 3, borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
          <img
            src="metaresearch_se_cropped.png"
            alt="MetaResearch.se Logo"
            style={{
              maxHeight: "40px",
              maxWidth: "100%",
              display: "block",
              objectFit: "contain",
            }}
          />
        </Box>
        <List>
          {tabs.map((tab) => (
            <ListItem
              key={tab}
              button
              onClick={() => handleNavigation(tab)}
              sx={{
                backgroundColor:
                  currentTab === tab ? "rgba(255,255,255,0.1)" : "transparent",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.05)",
                },
              }}
            >
              <ListItemText
                primary={tab}
                sx={{
                  "& .MuiListItemText-primary": {
                    fontWeight: currentTab === tab ? "bold" : "normal",
                    color: theme.palette.primary.contrastText,
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </AppBar>
  );
}
export default ResponsiveAppBar;
